import React from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Goals_GetGoals, Goals_InsertEditGoal } from '../../Services/Actions';

import * as styles from './styles';

import { toast } from 'react-toastify';

// import ButtonGroup from '../Buttons/ButtonGroup';
import Loading from '../Loading';
import PageText from '../Text/PageText';
import Spacer from '../Spacer';

import DownArrow from '../../Assets/Icons/DownArrow.png';
import UpArrow from '../../Assets/Icons/UpArrow.png';

// const DEFAULT_GOAL = { GoalId: 0, GoalStatus: 'Active', GoalText: '', IsFavorited: 0, ReviewDate: null, UserId: 0 }

class GoalsComponent extends React.Component {
    state = {
        DisplayGoals: false,

        Goals: [],
        Goal: {},

        UserId: null
    }

    componentDidMount() {
        this.setState({ UserId: this.props.UserId }, this.onGetGoals);
    }

    onGetGoals = () => {
        var { UserId } = this.state;

        this.props.Goals_GetGoals({ UserId }).then(({ Goals }) => {
            this.setState({ Goals });
        })
    }

    onInsertEditGoal = () => {
        var { Goal, UserId } = this.state;

        this.props.Goals_InsertEditGoal({ ...Goal, UserId }).then(() => {
            toast.success(this.props.t('daily_reminder_updated'), {
                position: "bottom-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });

            this.onGetGoals();
        });
    }

    onToggleDisplayGoals = () => {
        this.setState({ DisplayGoals: !this.state.DisplayGoals });
    }

    renderGoals = () => {
        if (!this.state.DisplayGoals) return null;

        var { t } = this.props;

        return (
            <styles.GoalsBox className="GoalsBox">
                <PageText FontFamily="semibold" FontSize="medium-2" JustifyContent="center" NoMargin Text={t('goals')} TextAlign="center" />

                <Spacer Size="small" />

                <pre>{JSON.stringify(this.state.Goals, null, 2)}</pre>
            </styles.GoalsBox>
        );
    }

    renderToggle = () => {
        return (
            <styles.AccordionIcon onClick={this.onToggleDisplayGoals}>
                <img src={this.state.DisplayGoals ? UpArrow : DownArrow} alt="Open and close the accordion" />
            </styles.AccordionIcon>
        );
    }

    render() {
        var { t } = this.props;
        var { TryingGoalsAction } = this.props;

        return (
            <>
                {(TryingGoalsAction) && <Loading />}

                <styles.GoalsAccordionTitleContainer className="GoalsAccordionTitleContainer">
                    <styles.GoalsAccordionTitle FontFamily="semibold" FontSize="medium-1" JustifyContent="flex-end" NoMargin Text={t('goals')} TextAlign="right" />

                    {this.renderToggle()}
                </styles.GoalsAccordionTitleContainer>

                <Spacer Size="extra-small" />

                {this.renderGoals()}
            </>
        );
    }
}

const mapStateToProps = state => {
    return {
        TryingGoalsAction: state.Goals.TryingGoalsAction,
        TryingGoalsActionError: state.Goals.TryingGoalsActionError
    };
};

export default withTranslation()(connect(mapStateToProps, { Goals_GetGoals, Goals_InsertEditGoal } )(GoalsComponent));